/* eslint-disable @typescript-eslint/no-use-before-define */
import { WiredDashboardHeader } from '@euler/app/tv/components/dashboard/Header';
import { SearchContextProvider } from '@euler/app/tv/components/dashboard/SearchContext';
import { activeTab$ } from '@euler/app/tv/functions/useActiveTabIndex';
import { BookmarksScreen } from '@euler/app/tv/pages/Bookmarks';
import { DashboardScreen } from '@euler/app/tv/pages/Dashboard';
import { HistoryScreen } from '@euler/app/tv/pages/History';
import { SearchScreen } from '@euler/app/tv/pages/Search';
import { SettingsScreen } from '@euler/app/tv/pages/Settings';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { ScreenToParams, spreadScreens } from '@euler/functions/spreadScreens';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useBehaviorSubjectUpdater } from '@euler/utils/hooks';
import {
  BottomTabBarProps,
  createBottomTabNavigator,
} from '@react-navigation/bottom-tabs';
import { memo, useEffect } from 'react';
import { View } from 'react-native';

const TabNav = createBottomTabNavigator();

const TabScreens = {
  Dashboard: DashboardScreen,
  History: HistoryScreen,
  Search: SearchScreen,
  Settings: SettingsScreen,
  Bookmarks: BookmarksScreen,
};

export type TabNavParams = ScreenToParams<typeof TabScreens>;

const TabBar = memo((props: BottomTabBarProps) => {
  const updateActiveTab = useBehaviorSubjectUpdater(activeTab$);
  useEffect(() => {
    updateActiveTab(props.state.routes[props.state.index].name as any);
  }, [props.state.index, props.state.routes, updateActiveTab]);
  return null;
});

export const TVHomeScreen = wrapNavigatorScreen(
  () => {
    const theme = usePresentationTheme();
    return (
      <SearchContextProvider>
        <View
          css={`
            flex: 1;
            background-color: ${theme.page.bg};
          `}
        >
          <WiredDashboardHeader />
          <LayoutProviderView
            fallbackToChildren
            css={`
              flex: 1;
            `}
          >
            <TabNav.Navigator
              screenOptions={{
                headerShown: false,
              }}
              tabBar={props => <TabBar {...props} />}
            >
              {spreadScreens(TabNav.Screen, TabScreens)}
            </TabNav.Navigator>
          </LayoutProviderView>
        </View>
      </SearchContextProvider>
    );
  },
  {
    title: '首页',
    headerShown: false,
  },
);
